module.exports = __webpack_public_path__ + "static/media/capstone-report.961fdbb8.pdf";